'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2, _class2, _temp2;

var _classList = require('class-list');

var _classList2 = _interopRequireDefault(_classList);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _animationHelper = require('animation-helper');

var _animationHelper2 = _interopRequireDefault(_animationHelper);

var _decorators = require('decorators');

require('compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
	if (!descriptor) return;
	Object.defineProperty(target, property, {
		enumerable: descriptor.enumerable,
		configurable: descriptor.configurable,
		writable: descriptor.writable,
		value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	});
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

function _initializerWarningHelper(descriptor, context) {
	throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Carousel = (_class = (_temp2 = _class2 = function (_Component) {
	_inherits(Carousel, _Component);

	function Carousel() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Carousel);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			cycle: false,
			leftIndex: 0,
			itemsVisible: 1,
			disabled: false
		}, _this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0], _this.sampleCount = 0, _this.ranWheel = false, _initDefineProp(_this, 'infinite', _descriptor, _this), _initDefineProp(_this, 'mode', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(Carousel, [{
		key: 'wheelTimeoutHandler',
		value: function wheelTimeoutHandler() {
			if (this.state.disabled) return;
			if (!this.ranWheel) {
				this.runWheel();
			}
			this.ranWheel = false;
			this.wheelTimeout = null;
			this.sampleCount = 0;
			this.wheelSamples = [0, 0, 0, 0, 0, 0, 0, 0, 0];
		}
	}, {
		key: 'wheel',
		value: function wheel(event) {
			var _this2 = this;

			if (this.state.disabled) return;
			if (this.state.itemsVisible >= this.children.length) return;
			if (this.ranWheel) {
				event.preventDefault();
				return;
			}
			console.log(event.deltaMode, event.deltaX, event.deltaY, event.deltaZ);
			this.sampleCount++;
			clearTimeout(this.wheelTimeout);
			this.wheelTimeout = setTimeout(this.wheelTimeoutHandler, 64);
			var offset = 1;
			if (event.deltaMode == 1) offset = 16;
			if (event.deltaMode == 2) offset = window.innerWidth;

			var delta = event.deltaX * offset;
			this.wheelSamples.shift();
			this.wheelSamples.push(delta);

			var dx = 0;
			if (this.wheelSamples.filter(function (v) {
				return Math.abs(_this2.wheelSamples[4]) - Math.abs(v) > 0;
			}).length == 8) {
				dx = this.wheelSamples[4];
			}
			if (dx) {
				this.runWheel();
				this.ranWheel = true;
				event.preventDefault();
			}
		}
	}, {
		key: 'runWheel',
		value: function runWheel() {
			if (this.state.disabled) return;
			var direction = this.wheelSamples[4] > 0 ? 1 : this.wheelSamples[4] < 0 ? -1 : 0;
			if (direction == 0) return;
			if (direction < 1) this.cyclePrev(true);else this.cycleNext(true);
		}
	}, {
		key: 'logTouchEvent',
		value: function logTouchEvent(event) {
			console.log(event.type + ': ' + this.mapTouches(event.touches) + ' | ' + this.mapTouches(event.changedTouches));
		}
	}, {
		key: 'mapTouches',
		value: function mapTouches(touchList) {
			return [].map.call(touchList, function (touch) {
				return touch.identifier + ' @ ' + touch.clientX + 'x' + touch.clientY;
			}).join(', ');
		}
	}, {
		key: 'touchStart',
		value: function touchStart(event) {
			if (this.state.disabled) return;
			this.logTouchEvent(event);
			if (this.inTouch) {
				this.rejectTouch = true;
				event.preventDefault();
				return;
			}
			this.inTouch = true;
			this.rejectTouch = false;
			this.touch = { ID: event.touches[0].identifier, X: event.touches[0].clientX, Y: event.touches[0].clientY };
			this.lastTouch = this.touch;
			this.stopped = false;
			// event.preventDefault();
			return;
		}
	}, {
		key: 'touchMove',
		value: function touchMove(event) {
			if (this.state.disabled) return;
			if (this.stopped) event.preventDefault();
			this.logTouchEvent(event);
			if (this.inTouch && !this.rejectTouch) {
				this.lastTouch = { ID: event.touches[0].identifier, X: event.touches[0].clientX, Y: event.touches[0].clientY };
				if (Math.abs(event.touches[0].clientX - this.touch.X) > 30) {
					console.log("touchMove(): trying to stop movement");
					this.stopped = true;
					event.preventDefault();
				}
			}
		}
	}, {
		key: 'touchEnd',
		value: function touchEnd(event) {
			if (this.state.disabled) return;
			if (this.stopped) event.preventDefault();

			this.logTouchEvent(event);
			if (this.inTouch && !this.rejectTouch && this.touch && this.lastTouch) {
				var delta, size;
				delta = this.lastTouch.X - this.touch.X;
				size = 340;
				if (Math.abs(delta) > 0.1 * size) {
					delta *= -1;
					if (delta < 0) this.cyclePrev(true);else this.cycleNext(true);
				}
			}
			this.inTouch = false;
			this.rejectTouch = false;
			this.touch = null;
			this.lastTouch = null;
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.media) {
				this.mediaQuery = window.matchMedia(this.props.media);
				this.mediaQuery.addListener(this.mediaQueryListener);
				this.mediaQueryListener();
			}
		}
	}, {
		key: 'mediaQueryListener',
		value: function mediaQueryListener() {
			// Enable when the media query specified by props.media matches
			var v = !this.mediaQuery.matches;
			if (v != this.state.disabled) {
				this.setState({ disabled: v });
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.setContentNode(null);
			if (this.mediaQuery) {
				this.mediaQuery.removeListener(this.mediaQueryListener);
				delete this.mediaQuery;
			}
		}
	}, {
		key: 'setContentNode',
		value: function setContentNode(node) {
			var _this3 = this;

			if (this.contentNode) {
				this.contentNode.removeEventListener('wheel', this.wheel, { passive: false });
				this.contentNode.removeEventListener('touchstart', this.touchStart, { passive: false });
				this.contentNode.removeEventListener('touchmove', this.touchMove, { passive: false });
				this.contentNode.removeEventListener('touchend', this.touchEnd, { passive: false });
			}
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.contentNode = node;
			if (node) {
				window.addEventListener('resize', this.resized);
				if (!this.props.noControls) {
					node.addEventListener('wheel', this.wheel, { passive: false });
					node.addEventListener('touchstart', this.touchStart, { passive: false });
					node.addEventListener('touchmove', this.touchMove, { passive: false });
					node.addEventListener('touchend', this.touchEnd, { passive: false });
				}
				if (this.props.period) {
					this.timer = setTimeout(function () {
						return _this3.cycleNext();
					}, this.props.period);
				}
				requestAnimationFrame(this.resized);
			} else {
				window.removeEventListener('resize', this.resized);
			}
		}
	}, {
		key: 'resized',
		value: function resized() {
			if (this.state.disabled) return;
			var w = document.body.clientWidth;
			var btn = this.contentNode.parentNode.parentNode.querySelector('.carousel-cycle-prev');
			var bw = btn ? 2 * btn.offsetWidth : 0;

			console.log('Carousel.resized(): container width = ' + w + 'px, total button width = ' + bw);

			// w -= bw;

			Object.assign(this.contentNode.style, { maxWidth: '', width: '', marginLeft: '', marginRight: '' });

			var itemWidth = this.contentNode.querySelector('.carousel-item:first-child').offsetWidth;

			var w1 = Math.floor(w / itemWidth) * itemWidth;
			w1 = Math.max(w1, itemWidth);

			if (!this.infinite) {
				w = w1;
			}

			Object.assign(this.contentNode.style, { maxWidth: w + 'px', width: w + 'px', marginLeft: 'auto', marginRight: 'auto' });
			this.setState({ itemsVisible: w1 / itemWidth });
		}
	}, {
		key: 'items',
		value: function items() {
			if (this.mode == 'slide') {
				var end = this.children.slice(this.state.leftIndex);
				if (this.infinite) {
					end = end.concat(this.children.slice(0, this.state.leftIndex));
				} else if (end.length < this.state.itemsVisible && end.length < this.children.length) {
					end = this.children.slice(this.children.length - this.state.itemsVisible);
				}
				return end;
			}
			return this.children;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			if (this.state.disabled) {
				return _react2.default.createElement(
					'div',
					{ className: _classList2.default.join('disabled-carousel-container') },
					_react2.default.createElement(
						'div',
						{ className: _classList2.default.join('carousel-content', this.props.listClassName || "") },
						this.children.map(function (carouselItem, index) {
							return _react2.default.createElement(
								'div',
								{ className: 'carousel-item', key: index, ref: function ref(node) {
										return _this4.setupDisabledCarouselItem(node, carouselItem);
									} },
								_this4.props.items ? null : carouselItem
							);
						})
					)
				);
			}
			var isActive = function isActive(node) {
				if (_this4.mode == 'slide') {
					return _this4.items().slice(0, _this4.state.itemsVisible).indexOf(node) != -1;
				}
				return _this4.state.leftIndex == _this4.items().indexOf(node);
			};

			return _react2.default.createElement(
				'div',
				{ className: _classList2.default.join('carousel-container', this.props.noControls ? 'carousel-without-controls' : null, this.props.indicators ? 'carousel-with-indicators' : null) },
				!this.props.noControls ? _react2.default.createElement(
					'div',
					{ className: 'carousel-cycle-prev' },
					this.state.itemsVisible < this.props.items.length ? _react2.default.createElement(
						'button',
						{ type: 'button', disabled: !this.infinite && this.state.leftIndex <= 0, onClick: function onClick() {
								return _this4.cyclePrev(true);
							} },
						_react2.default.createElement('span', { title: 'previous', className: 'arrow-circle-icon left', 'aria-hidden': true })
					) : null
				) : null,
				this.props.indicators ? _react2.default.createElement(
					'div',
					{ className: 'carousel-indicator-box' },
					this.props.items.map(function (carouselItem, index) {
						return _react2.default.createElement('div', { key: index,
							style: { transition: (_this4.props.speed || '300') + 'ms ease' },
							className: _classList2.default.join('carousel-indicator-item', isActive(carouselItem) ? 'active' : '')
						});
					})
				) : null,
				_react2.default.createElement(
					'div',
					{ className: _classList2.default.join('carousel-content', this.infinite ? '' : 'not-infinite', 'transition-' + this.mode, this.props.listClassName, this.state.itemsVisible >= this.props.items.length ? 'carousel-content-centered' : ''), ref: this.setContentNode },
					this.mode == 'slide' && this.state.itemsVisible < this.props.items.length ? _react2.default.createElement(
						'div',
						{ className: 'carousel-item previous-space', key: 'previous', ref: function ref(node) {
								return _this4.setupCarouselItem(node, null, "previous");
							} },
						this.props.items ? null : node
					) : null,
					this.items().map(function (carouselItem, index) {
						return _react2.default.createElement(
							'div',
							{ className: 'carousel-item', key: index, ref: function ref(node) {
									return _this4.setupCarouselItem(node, carouselItem);
								} },
							_this4.props.items ? null : node
						);
					}),
					/* We don't actually need a 'next-space' */null
				),
				!this.props.noControls ? _react2.default.createElement(
					'div',
					{ className: 'carousel-cycle-next' },
					this.state.itemsVisible < this.props.items.length ? _react2.default.createElement(
						'button',
						{ type: 'button', disabled: !this.infinite && this.state.leftIndex + this.state.itemsVisible >= this.props.items.length, onClick: function onClick() {
								return _this4.cycleNext(true);
							} },
						_react2.default.createElement('span', { title: 'next', className: 'arrow-circle-icon right', 'aria-hidden': true })
					) : null
				) : null
			);
		}
	}, {
		key: 'setupCarouselItem',
		value: function setupCarouselItem(node, carouselNode, asPreviousItem) {
			if (!carouselNode && asPreviousItem == 'previous') {
				if (this.infinite) {
					var t = this.items();
					carouselNode = t[t.length - 1];
					if (this.props.items) carouselNode = carouselNode.cloneNode(true);
				} else {
					var t = this.children.slice(this.state.leftIndex).concat(this.children.slice(0, this.state.leftIndex));
					carouselNode = t[t.length - 1];
					if (this.props.items) carouselNode = carouselNode.cloneNode(true);
				}
			}

			if (node) {
				if (this.mode == 'slide') {
					if (this.props.noTransform) node.style.left = '';else node.style.transform = '';
				} else {
					var t = this.items();
					var pos = t.indexOf(carouselNode);
					if (pos == this.state.leftIndex) {
						node.style.zIndex = 2;
						node.style.opacity = 1;
					} else {
						node.style.zIndex = node.style.opacity = 0;
					}
				}
				if (this.props.items) {
					while (node.firstChild) {
						node.removeChild(node.firstChild);
					}node.appendChild(carouselNode);
				}
			}
		}
	}, {
		key: 'setupDisabledCarouselItem',
		value: function setupDisabledCarouselItem(node, carouselNode) {
			if (node) {
				if (this.props.noTransform) node.style.left = '';else node.style.transform = '';

				if (this.props.items) {
					while (node.firstChild) {
						node.removeChild(node.firstChild);
					}node.appendChild(carouselNode);
				}
			}
		}
	}, {
		key: 'cyclePrev',
		value: function cyclePrev() {
			var _this5 = this;

			var userTriggered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (this.animation) return;
			if (this.state.disabled) return;
			if (!this.infinite && this.state.leftIndex <= 0) return;

			if (this.state.itemsVisible >= this.props.items.length) {
				if (this.props.period) this.timer = setTimeout(function () {
					return _this5.cycleNext();
				}, this.props.period);
				return;
			}

			var positionCallback, finishedCallback;

			finishedCallback = function finishedCallback(finished) {
				if (!finished) positionCallback(1);
				delete _this5.animation;
				_this5.setState(function (state) {
					var lp = state.leftIndex - 1;
					if (_this5.infinite) {
						if (lp == -1) lp = _this5.props.items.length - 1;
					} else {
						if (lp < 0) lp = 0;
					}
					return { leftIndex: lp };
				});
				clearTimeout(_this5.timer);
				if (_this5.props.period) _this5.timer = setTimeout(function () {
					return _this5.cycleNext();
				}, _this5.props.period);
			};

			switch (this.mode) {
				case 'slide':
					positionCallback = function positionCallback(position) {
						var pp = -100 + 100 * position;
						console.log(pp);
						var mode = _this5.props.noTransform ? function (node) {
							return node.style.left = pp + '%';
						} : function (node) {
							return node.style.transform = 'translateX(' + pp + '%)';
						};
						_this5.contentNode.querySelectorAll(':scope > .carousel-item').forEach(mode);
					};
					break;
				case 'fade':
					positionCallback = function positionCallback(position) {
						var cq = _this5.contentNode.querySelectorAll(':scope > .carousel-item');
						var c1 = cq[_this5.state.leftIndex - 1] || cq[cq.length - 1]; // target
						var c2 = cq[_this5.state.leftIndex]; // current
						var cr = [].filter.call(cq, function (node) {
							return node != c1 && node != c2;
						});
						if (c1) {
							c1.style.opacity = position;
							c1.style.zIndex = 2;
						}
						if (c2) {
							c2.style.opacity = 1 - position;
							c2.style.zIndex = 1;
						}
						cr.forEach(function (node) {
							node.style.opacity = 0;
							node.style.zIndex = 0;
						});
					};
					break;
			}

			this.animation = new _animationHelper2.default(userTriggered ? 300 : this.props.speed || 300, 'ease', positionCallback, finishedCallback);
			requestAnimationFrame(function () {
				_this5.animation.start();
			});
		}
	}, {
		key: 'cycleNext',
		value: function cycleNext() {
			var _this6 = this;

			var userTriggered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			if (this.animation) return;
			if (this.state.disabled) return;
			if (!this.infinite && this.state.leftIndex + this.state.itemsVisible >= this.children.length) return;
			if (this.state.itemsVisible >= this.props.items.length) {
				if (this.props.period) this.timer = setTimeout(function () {
					return _this6.cycleNext();
				}, this.props.period);
				return;
			}

			var positionCallback;
			switch (this.mode) {
				case 'slide':
					positionCallback = function positionCallback(position) {
						var pp = -100 - 100 * position;
						var mode = _this6.props.noTransform ? function (node) {
							return node.style.left = pp + '%';
						} : function (node) {
							return node.style.transform = 'translateX(' + pp + '%)';
						};
						_this6.contentNode.querySelectorAll(':scope > .carousel-item').forEach(mode);
					};
					break;
				case 'fade':
					positionCallback = function positionCallback(position) {
						var cq = _this6.contentNode.querySelectorAll(':scope > .carousel-item');
						var c1 = cq[_this6.state.leftIndex + 1] || cq[0]; // target
						var c2 = cq[_this6.state.leftIndex]; // current
						var cr = [].filter.call(cq, function (node) {
							return node != c1 && node != c2;
						});
						if (c1) {
							c1.style.opacity = position;
							c1.style.zIndex = 2;
						}
						if (c2) {
							c2.style.opacity = 1 - position;
							c2.style.zIndex = 1;
						}
						cr.forEach(function (node) {
							node.style.zIndex = node.style.opacity = 0;
						});
					};
					break;
			}

			var finishedCallback = function finishedCallback(finished) {
				if (!finished) positionCallback(1);
				delete _this6.animation;
				_this6.setState(function (state) {
					var lp = state.leftIndex + 1;
					if (_this6.infinite) {
						if (lp == _this6.props.items.length) lp = 0;
					} else {
						if (state.leftIndex + state.itemsVisible >= _this6.children.length) {
							lp = _this6.children.length - state.itemsVisible;
						}
					}
					return { leftIndex: lp };
				});
				clearTimeout(_this6.timer);
				if (_this6.props.period) _this6.timer = setTimeout(function () {
					return _this6.cycleNext();
				}, _this6.props.period);
			};
			this.animation = new _animationHelper2.default(userTriggered ? 300 : this.props.speed || 300, 'ease', positionCallback, finishedCallback);
			requestAnimationFrame(function () {
				_this6.animation.start();
			});
		}
	}, {
		key: 'children',
		get: function get() {
			if (this.props.items) return this.props.items;
			if (this._lastChildren === this.props.children) return this._lastChildrenArray;
			this._lastChildrenArray = _react2.default.Children.toArray(this.props.children);
			this._lastChildren = this.props.children;
			return this._lastChildrenArray;
		}
	}], [{
		key: 'setup',
		value: function setup(parent, props) {
			var carouselItems = [].slice.call(parent.childNodes).filter(function (node) {
				return node.nodeType == 1;
			});
			var classNames = parent.className;
			while (parent.firstChild) {
				parent.removeChild(parent.firstChild);
			}parent.className = "";

			props = Object.assign({}, props || {});
			_reactDom2.default.render(_react2.default.createElement(Carousel, _extends({ items: carouselItems, listClassName: classNames }, props)), parent);
			var ret = {
				remove: function remove() {
					_reactDom2.default.unmountComponentAtNode(parent);
					for (var i = 0; i < carouselItems.length; i++) {
						parent.appendChild(carouselItems[i]);
					}
					Carousel.carousels = Carousel.carousels.filter(function (node) {
						if (node == ret) return false;
						if (document.documentElement.contains(node._parent)) return true;

						_reactDom2.default.unmountComponentAtNode(node._parent);
						return false;
					});
				},

				_parent: parent
			};
			this.carousels.push(ret);
			this.carousels = this.carousels.filter(function (node) {
				if (document.documentElement.contains(node._parent)) return true;

				_reactDom2.default.unmountComponentAtNode(node._parent);
				return false;
			});
			return ret;
		}
	}]);

	return Carousel;
}(_react.Component), _class2.carousels = [], _temp2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'infinite', [_decorators.prop], {
	enumerable: true,
	initializer: function initializer() {
		return false;
	}
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'mode', [_decorators.prop], {
	enumerable: true,
	initializer: function initializer() {
		return "slide";
	}
}), _applyDecoratedDescriptor(_class.prototype, 'wheelTimeoutHandler', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'wheelTimeoutHandler'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'wheel', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'wheel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'touchStart', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'touchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'touchMove', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'touchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'touchEnd', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'touchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'mediaQueryListener', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'mediaQueryListener'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setContentNode', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'setContentNode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resized', [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, 'resized'), _class.prototype)), _class);
exports.default = Carousel;